import { UpdateCsvExcelTradesAdditionsApi } from "@/features/accounts/csv-excel/services/update-trades-additions-api";
import { UpdateCsvExcelTradesAdditionsRequestModel } from "@/features/accounts/csv-excel/services/update-trades-additions-model";

/// CSV/Excel明細メモ・無効明細更新処理
export class UpdateCsvExcelTradesAdditionsService {
  private updateCsvExcelTradesAdditionsApi = new UpdateCsvExcelTradesAdditionsApi();

  /**
   * CSV/Excel明細メモ・無効明細更新API実行
   */
  public async updateCsvExcelTradesAdditions(param: UpdateCsvExcelTradesAdditionsRequestModel) {
    return await this.updateCsvExcelTradesAdditionsApi.updateCsvExcelTradesAdditions(param);
  }
}
